import { useContext } from "react";
import { StoreContext } from "../context/contextStore";

const useStore = () => {
  return useContext(StoreContext);
};
export default useStore;
